export * from '@MerchantConfigurator/constants/analytics';
export * from '@MerchantConfigurator/constants/colors';
export * from '@MerchantConfigurator/constants/elementIDs';
export * from '@MerchantConfigurator/constants/messaging/configurations';
export * from '@MerchantConfigurator/constants/messaging/contents';
export * from '@MerchantConfigurator/constants/messaging/errors';
export * from '@MerchantConfigurator/constants/messaging/inputRegexPatterns';
export * from '@MerchantConfigurator/constants/previewSectionStyles';
export * from '@MerchantConfigurator/constants/styles';

export const Countries = {
  AU: 'AU',
  DE: 'DE',
  ES: 'ES',
  FR: 'FR',
  GB: 'GB',
  IT: 'IT',
  US: 'US'
};

export const DynamicLayoutBlocks = {
  CONTAINER: 'container',
  TEXT: 'text',
  IMAGE: 'image',
  NODE: 'node',
  UPSTREAMMESSAGE: 'upstreamMessage'
};

export const PayPalHostedExperiences = ['financeportal', 'DevDocs'];

export const BundleSources = {
  previewBundleUrl:
    'https://www.paypalobjects.com/merchant-library/preview/merchant-configurator.js',
  prodBundleUrl: 'https://www.paypalobjects.com/merchant-library/merchant-configurator.js'
};

export const DefaultLocale = 'en-US';

export const SupportedLocales = new Set([
  'de-DE',
  'en-AU',
  'en-DE',
  'en-ES',
  'en-FR',
  'en-GB',
  'en-IT',
  'en-US',
  'es-ES',
  'fr-FR',
  'it-IT'
]);

export const errorImageUrl =
  'https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-critical.svg';
export const errorImageAlt = 'Warning icon';

export const merchantIdentifiers = {
  PAYER_ID: 'PAYER_ID',
  CLIENT: 'CLIENT'
};
